import React, { CSSProperties, useCallback } from "react";
import cn from "classnames";
import { InputLabel } from "./InputLabel";

type Props = {
  id?: string;
  label?: string;
  checked?: boolean;
  disabled?: boolean;
  defaultChecked?: boolean;
  style?: CSSProperties;
  className?: string;
  labelHint?: string;
  onChange: (value: boolean, e: React.SyntheticEvent<HTMLInputElement>) => void;
};

export const InputCheckbox: React.FC<Props> = ({
  id,
  disabled,
  label,
  defaultChecked,
  checked,
  style,
  className,
  labelHint,
  onChange,
}) => {
  const handleChange = useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      onChange(e.currentTarget.checked, e);
    },
    [onChange],
  );
  return (
    <>
      <div>
        <input
          id={id}
          disabled={disabled ?? false}
          defaultChecked={defaultChecked}
          className={cn(
            "h-4 w-4 mt-1 border border-gray-300 rounded-sm bg-white focus:outline-none checked:bg-blue-600 checked:border-blue-600 transition duration-200 align-top bg-no-repeat bg-center bg-contain float-left cursor-pointer",
            className,
          )}
          style={style}
          type="checkbox"
          onChange={handleChange}
          checked={checked}
        />
        {label && (
          <>
            <InputLabel
              label={label}
              labelHint={labelHint}
              className={{ label: "ml-1" }}
            />
          </>
        )}
      </div>
    </>
  );
};
